// Package imports:
import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import Bugsnag from '@bugsnag/js';
// Action imports:
import { systemProfileFailover, startLogOutTimer, requestUserInfo } from '../../redux-store/actions/loginActions';
import { clearFailover } from '../../redux-store/actions/privateActions';
// Type imports:
import { RootState } from '../../redux-store/reducers';
import { isUserLoggedIn } from '../../services/loginUtils';

type ReduxProps = ConnectedProps<typeof connector>
type Props = ReduxProps;

/**
 * This component checks properties of the login reducer and decides whether to take action.
 * For example:
 * - check if token is expired and validate refreshtoken.
 * - check if needs to fetch extra data.
 */
const LoginControlCenter: React.FC<Props> = ({
    accessTokenV2,
    isLoggedIn,
    groupId,
    loginUserName,
    clearFailover,
    systemProfileFailover,
    requestUserInfo
}) => {
    // Bugsnag on mount. Only if in production.
    useEffect(() => {
        if (isLoggedIn && (process.env.REACT_APP_NODE_ENV === 'production' || process.env.REACT_APP_NODE_ENV === 'staging')) {
            const userEmail = loginUserName || null;
            const currentEmail = Bugsnag.getMetadata('user', 'email');
            if (!currentEmail) {
                Bugsnag.addMetadata('user', {
                    email: userEmail
                });
            }
            const currentToken = Bugsnag.getMetadata('user', 'token');
            if (!currentToken) {
                Bugsnag.addMetadata('user', {
                    token: accessTokenV2
                });
            }
            const version = Bugsnag.getMetadata('app', 'version');
            if (!version) {
                Bugsnag.addMetadata('app', {
                    version: process.env.REACT_APP_VERSION
                });
            }
        }
    // eslint-disable-next-line
    }, []);

    // Request User Info.
    useEffect(() => {
        if (isLoggedIn && groupId === null && loginUserName === "") {
            requestUserInfo(accessTokenV2);
        }
    // eslint-disable-next-line
    }, [ isLoggedIn, groupId, loginUserName, requestUserInfo ]);

    return (
        <div id='LoginControlCenter' />
    );
}

function mapStateToProps({ loginReducer, privateReducer }: RootState) {
    const {
        accessTokenV2,
        username,
        password,
        groupId,
        loginUserName
    } = loginReducer;
    const { isLoggedIn } = isUserLoggedIn(loginReducer);
    return {
        accessTokenV2,
        username,
        password,
        isLoggedIn,
        groupId,
        loginUserName
    };
}

const connector = connect(mapStateToProps, {
    clearFailover,
    systemProfileFailover,
    startLogOutTimer,
    requestUserInfo
});
export default connector(LoginControlCenter);